<template>
  <input
    invisible-file-input
    type="file"
    :multiple="multiple"
  >
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    $fileBrowser: null,
    files: [],
    uploadSuccessFiles: [],
    loading: false,
  }),
  mounted() {
    this.initFileBrowser()
  },
  methods: {
    async initFileBrowser() {
      await this.$nextTick()
      this.$fileBrowser = $(this.$el)
      this.$fileBrowser.change(event => {
        this.handleFileChange(event.target.files)
      })
    },
    openFileBrowser() {
      if(this.loading) {
        this.resetFileBrowser()
        return
      }
      this.$fileBrowser.click()
    },
    resetFileBrowser() {
      this.$fileBrowser.val('')
    },
    async handleFileChange(files) {
      this.files = []
      if(files.length == 0) {
        this.resetFileBrowser()
        return
      }

      if(this.loading) return
      this.loading = true
      this.uploadSuccessFiles = []
      for(let index=0; index<=files.length-1; index++) {
        const file = files[index]
        await this.uploadFile(file)
      }

      await this.$helper.delay(0.5)
      this.$emit('uploadAllCompleted', window.eagleLodash.cloneDeep(this.uploadSuccessFiles))
      this.loading = false
      this.resetFileBrowser()
      this.init()
    },
    async uploadFile(file) {
      if(this.$helper.isImage(file) === false) {
        this.$snotify.error(
          this.$t('photo.validation.image.incorrect'),
          this.$t('photo.upload.fail')+`( ${file.name} )`
        )
        return
      }

      const formData = new FormData()
      formData.append('file', file)
      const params = {
        type: this.type,
        config: this.photoUploadConfig[this.type] || 'default',
      }
      try {
        const result = await this.uploadApi(formData, this.onProgress, params)
        this.uploadSuccessFiles.push(result)
        this.$emit('appendPhoto', result)
        this.$snotify.success(
          file.name,
          this.$t('photo.upload.success')
        )
      } catch (error) {
        this.$emit('error')
        console.error(error)
        let message = null
        if(error.status == 406) message = this.$t(`error.storage.out_of_limit`)
        this.$snotify.error(
          message,
          this.$t('photo.upload.fail')
        )
      }
    },
    init() {
      this.$fileBrowser.val('')
      this.files = []
      this.uploadSuccessFiles = []
    },
  },
  computed: {
    photoUploadConfig() {
      return this.$store.getters['photo/photoUploadConfig']
    },
    uploadApi() {
      return this.$api.collection.photoApi.upload
    },
  },
  watch: {
    loading() {
      this.$emit('onLoadingChange', this.loading)
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped>
input[type="file"][invisible-file-input]
  width: 0
  height: 0
  opacity: 0
  position: absolute
  pointer-events: none
</style>
